import React from 'react';
import '../styles/skills.css';

const Skills = () => {
  const skillCategories = [
    {
      category: 'Programming Languages',
      skills: ['C++', 'C', 'Python', 'Java', 'C#', 'Problem Solving']
    },
    {
      category: 'Web Development',
      skills: ['HTML', 'CSS', 'React', 'TypeScript']
    },
    {
      category: 'Mobile Development',
      skills: ['Dart', 'Flutter', 'Android Studio']
    },
    {
      category: 'AI & Data',
      skills: ['Machine Learning', 'Data Structures', 'Algorithms']
    },
    {
      category: 'Databases',
      skills: ['SQL', 'Database Design']
    },
    {
      category: 'Tools & Others',
      skills: ['Git', 'GitHub', 'VS Code', 'Linux']
    },
    {
      category: 'Soft Skills',
      skills: ['Leadership', 'Teamwork', 'Event Planning']
    },
    {
      category: 'Languages',
      skills: ['Romanian (Native)', 'English (C2 - Cambridge Certified)']
    }
  ];

  return (
    <section id="skills" className="skills-section">
      <div className="skills-container">
        <div className="section-header">
          <h2 className="section-title">Skills & Expertise</h2>
          <div className="section-divider"></div>
          <p className="section-description">
            A comprehensive overview of my technical and professional competencies
          </p>
        </div>

        <div className="skills-grid">
          {skillCategories.map((category, index) => (
            <div key={index} className="skill-category">
              <h3 className="category-title">{category.category}</h3>
              <div className="skills-list">
                {category.skills.map((skill, skillIndex) => (
                  <span key={skillIndex} className="skill-tag">{skill}</span>
                ))}
              </div>
            </div>
          ))}
        </div>

        <div className="certifications">
          <h3 className="certifications-title">Certifications</h3>
          <div className="cert-list">
            <a 
              href="https://www.hackerrank.com/certificates/1d0840b93d36" 
              target="_blank" 
              rel="noopener noreferrer"
              className="cert-item cert-item-link"
            >
              <div className="cert-name">Python Certificate</div>
              <div className="cert-issuer">HackerRank</div>
            </a>
            <a 
              href="https://www.hackerrank.com/certificates/2afd379c7bb9" 
              target="_blank" 
              rel="noopener noreferrer"
              className="cert-item cert-item-link"
            >
              <div className="cert-name">Problem Solving Certificate</div>
              <div className="cert-issuer">HackerRank</div>
            </a>
            <div className="cert-item">
              <div className="cert-name">Cambridge English C2</div>
              <div className="cert-issuer">Cambridge Assessment</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Skills;